import TypographyDataBaseType from './TypographyDataBaseType';

export default TypographyDataBaseType;
